import { useEffect, useState, createContext } from "react";

const AppContext = createContext();
const API_URL = `https://www.omdbapi.com/?apikey=${process.env.REACT_APP_API_KEY}`;
const AppProvider = ({ children }) => {
  const [movies, setMovies] = useState([]);
  const [query, setQuery] = useState("titanic");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const fetchMovies = async (api) => {
    try {
      const res = await fetch(api);
      const data = await res.json();
      console.log(data);
      if (data.Response === "True") {
        setMovies(data.Search);
        setIsLoading(false);
        setError("");
      } else {
        setError(data.Error);
        setIsLoading(true);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    var timeRef = setTimeout(() => {
      fetchMovies(`${API_URL}&s=${query}`);
    }, 1000);
    return () => {
      clearTimeout(timeRef);
    };
  }, [query, error, isLoading]);

  return (
    <AppContext.Provider value={{ movies, query, setQuery, error, isLoading }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
